module.exports = __webpack_public_path__ + "img/FrameFoundations_s0_b0_0_1_SSC_UK.7e023c02.png";